import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/theme/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Realisations from "@/pages/Realisations";
import RealisationCategory from "@/pages/RealisationCategory";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Mentions from "@/pages/Mentions";
import Confidentialite from "@/pages/Confidentialite";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/serrurerie" element={<ServicePage />} />
            <Route path="/metallerie" element={<ServicePage />} />
            <Route path="/vitrerie" element={<ServicePage />} />
            <Route path="/depannage" element={<ServicePage />} />
            <Route path="/realisations" element={<Realisations />} />
          <Route path="/realisations/:slug" element={<RealisationCategory />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Mentions />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
